import { create } from "zustand";
import { persist } from "zustand/middleware";

export type AppearanceMode = "light" | "dark";

interface AppearanceState {
  mode: AppearanceMode;
  setMode: (mode: AppearanceMode) => void;
}

export const useAppearanceStore = create<AppearanceState>()(
  persist(
    (set) => ({
      mode: "light",
      setMode: (mode) => set({ mode }),
    }),
    { name: "fast-appearance" }
  )
);
